export class ElementUtils {
    static wholeValue: any = (value: any) => value;
}
